/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var Error;
(function (Error) {
    /**
     * Immutable string representing a specific error.
     */
    let error_code;
    (function (error_code) {
        error_code["ACCOUNT_SUSPENDED"] = "account_suspended";
        error_code["INVALID_SELECTED_ACCOUNT_ID"] = "invalid_selected_account_id";
        error_code["BUNDLE_SELECTION_NOT_100_PCT"] = "bundle_selection_not_100_pct";
        error_code["ALL_BUNDLES_MUST_BE_ENABLED"] = "all_bundles_must_be_enabled";
        error_code["ORDER_IDEMPOTENCY_FAILURE"] = "order_idempotency_failure";
        error_code["ORDER_QUANTITY_NON_POSITIVE"] = "order_quantity_non_positive";
        error_code["INVALID_BUNDLE_ID"] = "invalid_bundle_id";
        error_code["INVALID_ID"] = "invalid_id";
        error_code["BUNDLE_SELECTION_RATIOS_INVALID"] = "bundle_selection_ratios_invalid";
        error_code["BUNDLE_SELECTION_BUNDLE_INVALID"] = "bundle_selection_bundle_invalid";
        error_code["ORDER_IDEMPOTENCY_ALREADY_EXISTS"] = "order_idempotency_already_exists";
        error_code["ORDER_QUANTITY_INVALID"] = "order_quantity_invalid";
        error_code["BUNDLE_ID_INVALID"] = "bundle_id_invalid";
        error_code["ID_INVALID"] = "id_invalid";
        error_code["TEST_ACCOUNT_NAME_UPDATE_DISALLOWED"] = "test_account_name_update_disallowed";
        error_code["VALIDATION_ERROR"] = "validation_error";
        error_code["PERCENTAGE_ALL_OR_NONE"] = "percentage_all_or_none";
        error_code["BUNDLE_SELECTION_RATIOS_INVALID_FORMAT"] = "bundle_selection_ratios_invalid_format";
        error_code["ADDRESS_NOT_FOUND"] = "address_not_found";
        error_code["AT_LEAST_ONE_CONSTRAINT_REQUIRED"] = "at_least_one_constraint_required";
        error_code["BUNDLES_SIZE_NOT_SUPPORTED"] = "bundles_size_not_supported";
        error_code["OFFSET_LINK_CONSTRAINT_REQUIRED"] = "offset_link_constraint_required";
        error_code["OFFSET_LINK_BUNDLES_SIZE_INVALID"] = "offset_link_bundles_size_invalid";
        error_code["WEBHOOK_LIMIT_REACHED"] = "webhook_limit_reached";
        error_code["INVALID_TIME_RANGE"] = "invalid_time_range";
        error_code["TIME_RANGE_INVALID"] = "time_range_invalid";
        error_code["EXCHANGE_RATE_NOT_FOUND"] = "exchange_rate_not_found";
        error_code["LIVE_ACCOUNT_REQUIRED"] = "live_account_required";
        error_code["UNAUTHORISED"] = "unauthorised";
        error_code["ESTIMATE_NOT_FOUND"] = "estimate_not_found";
        error_code["ESTIMATE_ORDER_ALREADY_PLACED"] = "estimate_order_already_placed";
    })(error_code = Error.error_code || (Error.error_code = {}));
})(Error || (Error = {}));
//# sourceMappingURL=Error.js.map